import { AlertTriangle, RotateCw } from "lucide-react";
import { RECEPCION } from "@/constants/testIds";

const MENSAJES = {
  sesion: "El servidor no reconoció la sesión de Recepción en este dispositivo.",
  permiso: "Esta cuenta no tiene permiso para consultar los eventos de Recepción.",
  red: "No se pudo conectar con el servidor de Recepción.",
  servidor: "El servidor de Recepción respondió con un error.",
  respuesta: "El servidor de Recepción devolvió una respuesta inesperada.",
};

export const EventosCargaError = ({ error, onReintentar, onRelogin }) => (
  <div
    data-testid={RECEPCION.seleccionError}
    role="alert"
    className="flex flex-col items-start gap-4 rounded-2xl border hairline bg-card p-8 md:p-12 shadow-soft animate-fade-up"
  >
    <div className="grid place-items-center w-14 h-14 rounded-2xl bg-destructive/10 text-destructive">
      <AlertTriangle className="w-6 h-6" strokeWidth={1.5} />
    </div>
    <span className="overline text-destructive">No se pudieron cargar los eventos</span>
    <p className="text-foreground max-w-md leading-relaxed">
      {MENSAJES[error?.tipo] || MENSAJES.servidor}
    </p>
    <p
      data-testid={RECEPCION.seleccionErrorCodigo}
      className="text-xs text-muted-foreground"
    >
      Código: {error?.status ? `HTTP ${error.status}` : "sin respuesta"} · {error?.tipo || "desconocido"}
      {error?.categoria ? ` · ${error.categoria}` : ""}
    </p>
    <div className="flex flex-wrap gap-3">
      <button
        type="button"
        data-testid={RECEPCION.seleccionReintentar}
        onClick={onReintentar}
        className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm text-primary-foreground hover:opacity-90 transition-opacity"
      >
        <RotateCw className="w-4 h-4" strokeWidth={1.6} /> Reintentar
      </button>
      {error?.tipo === "sesion" && (
        <button
          type="button"
          data-testid={RECEPCION.seleccionRelogin}
          onClick={onRelogin}
          className="rounded-full border hairline px-5 py-2.5 text-sm text-foreground hover:bg-muted transition-colors"
        >
          Iniciar sesión de nuevo
        </button>
      )}
    </div>
  </div>
);

export default EventosCargaError;
